(function (ws) {
    'use strict';
    ws.views.productPagination = Backbone.View.extend({
        /**
         * event handlers
         */
        events: {
            'click .pagination-link': 'submitPaginationForm'
        },

        /**
         * Select all check boxes
         * @param {Object} e
         */
        submitPaginationForm: function(e) {
            e.preventDefault();
            $(e.target).closest('form').submit();
        }
    });
})(westcon);
